module.exports = __webpack_public_path__ + "img/t2-intro-text.6fb530fb.png";